export default "__VITE_ASSET__Z_HUzuya__"